import { useEffect, useState } from 'react';
import { getSubCategory } from '../../service/service';
import { Link, useParams } from 'react-router-dom';

export default function ActebiList() {
	const [list, setList] = useState([]);
	const { slug } = useParams();
	console.log(slug);

	useEffect(() => {
		const getList = async () => {
			await getSubCategory().then(item => {
				setList(item);
			});
		};
		getList();
	}, []);

	return (
		<>
			{list?.map(item => (
				<span key={item.id} className={item.slug === slug ? 'active' : ''}>
					<Link
						to={
							item.slug === 'sakrebulo'
								? `sakrebulo/${item.slug}`
								: `/komisiebis-skhdomis-oqmebi/${item.slug}`
						}
					>
						{item.title}
					</Link>
				</span>
			))}
		</>
	);
}
